import BigNumber from "bignumber.js";
import conquerorImg from "src/assets/images/rank/conqueror.png";
import heroImg from "src/assets/images/rank/hero.png";
import legendaryImg from "src/assets/images/rank/legendary.png";
import masterImg from "src/assets/images/rank/master.png";
import warriorImg from "src/assets/images/rank/warrior.png";

import abandonImg from "src/assets/images/payout/abandon_bg.svg";
import completeImg from "src/assets/images/payout/complete.png";
import excelentImg from "src/assets/images/payout/excelent.png";
import notCompleteImg from "src/assets/images/payout/not_complete.png";

import LargeBanner from "src/assets/images/dilution-staking/large-banner.png";
import MediumBanner from "src/assets/images/dilution-staking/medium-banner.png";
import SmallBanner from "src/assets/images/dilution-staking/small-banner.png";

export const environment = process.env.REACT_APP_TARGET_NETWORK; // mainnet | testnet
export const RENT_CONTRACT_TIME_BASE = parseInt(process.env.REACT_APP_RENT_CONTRACT_TIME_BASE);
export const MIN_PRICE_PER_HOUR_FOR_RENT = process.env.REACT_APP_MIN_PRICE_PER_HOUR_FOR_RENT || "50";
export const BNB_MIN_PRICE_PER_HOUR_FOR_RENT = process.env.REACT_APP_BNB_MIN_PRICE_PER_HOUR_FOR_RENT || "0.002";
export const MIN_PRICE_FOR_SALE = process.env.REACT_APP_MIN_PRICE_FOR_SALE || "1";
export const INVENTORY_SIZE = process.env.REACT_APP_INVENTORY_SIZE || 50;

// bridge config
export const sidechainIdHex = environment == "mainnet" ? "0x1" : "0xaa36a7";
export const sidechainId = environment == "mainnet" ? "1" : "11155111";
export const mainchainIdHex = environment == "mainnet" ? "0x38" : "0x61";
export const mainchainId = environment == "mainnet" ? "56" : "97";

export const APR = { 1: 1500, 2: 1000, 3: 500 };

export const BASE18 = BigNumber("1000000000000000000");
export const BASE8 = BigNumber("100000000");
export const BASE9 = BigNumber("1000000000");

export const TxStatus = {
  WAIT_USER_CONFIRM_TX: 0,
  TX_EXECUTING: 1,
  TX_SUCCESS: 2,
  TX_FAILED: 3,
};

export const FS = {
  INITIAL: "INITIAL",
  FETCHING: "FETCHING",
  SUCCESS: "SUCCESS",
  FAIL: "FAIL",
  UPDATING: "UPDATING",
};

export const MAX_DATE = 8640000000000000;

export const UserRank = {
  warrior: { rank: "Warrior", img: warriorImg },
  conqueror: { rank: "Conqueror", img: conquerorImg },
  hero: { rank: "Hero", img: heroImg },
  master: { rank: "Master", img: masterImg },
  legendary: { rank: "Legendary", img: legendaryImg },
};

// api config
export const TRAVA_BACKEND_ROOT = "https://backend.trava.finance";
export const TRAVA_NFT_BACKEND_ROOT = "https://backend-nft-app.trava.finance";
export const SCORING_BACKEND_ROOT = "https://scoringapi.trava.finance";

// the graph config
export const THE_GRAPH_ROOT = "https://api.thegraph.com/subgraphs/name/zennomi/trava-bsc";
export const ArmourElement = ["exp", "rarity", "id", "type", "setId"];
export const NftCollectionElement = ["id", "owner", "rarity", "setId", "assembleAddress", "exp"];
export const HeuristicFramingElement = [
  "id",
  "owner",
  "rewardClaimed",
  "timeFarmed",
  "timePolish",
  "timestampStake",
  "vaultType",
  "isStake",
  "lastPolishTimestamp",
];
export const MarketplaceElement = ["buyer", "id", "price", "seller", "status"];

// payout for expedition and treasure map
export const payoutItem = [
  { id: 0, img: notCompleteImg, title: "MISSION FAILED", color: "#9A9A9A" },
  { id: 1, img: completeImg, title: "MISSION ACCOMPLISHED", color: "#3EC200" },
  { id: 2, img: excelentImg, title: "MISSION OVERPERFORMED", color: "#B926DA" },
  { id: 3, img: abandonImg, title: "MISSION ABANDONED", color: "#9A9A9A" },
];

// dilution staking
export const DilutionRank = ["small", "medium", "large"];
export const DilutionVaultConfig = {
  small: { img: SmallBanner, text: "squad", maximum: 100000, powerRating: 15, condition: [1, 2, 3] },
  medium: { img: MediumBanner, text: "platoon", maximum: 1000000, powerRating: 75, condition: [1, 2, 3, 4] },
  large: { img: LargeBanner, text: "company", maximum: "unlimited", powerRating: 350, condition: [1, 2, 3, 4, 5] },
};

export const TimeLockPercentage = [
  { text: "6 Months", date: environment == "mainnet" ? 15552000 : 60, percent: 0.159 },
  { text: "1 Year", date: environment == "mainnet" ? 31104000 : 120, percent: 0.38 },
  { text: "1.5 Years", date: environment == "mainnet" ? 46656000 : 180, percent: 0.685 },
  { text: "2 Years", date: environment == "mainnet" ? 77760000 : 240, percent: 1 },
];

export const MaxDilutionTravaLock = [10000, 500000, 1000000, 5000000, "unlimited"];
export const DilutionJoinFee = [500, 1320, 3600, 8666.67, 84000];
